import { Component, OnInit } from "@angular/core";
import { TuiInputModule } from "@taiga-ui/legacy";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { TuiAlertService, TuiButton, TuiError, TuiLink } from "@taiga-ui/core";
import { TuiFieldErrorPipe } from "@taiga-ui/kit";
import { AsyncPipe, CommonModule } from "@angular/common";
import { getHttpErrorMessage } from "../../shared/utils/http-error.util";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ForgotResetPasswordService } from "../../core/services/forgot-reset-password.service.service";
import { catchError, of } from "rxjs";
import { EnterSubmitDirective } from "../../core/directives/enter-submit.directive";

@Component({
  selector: "app-forgot-password",
  imports: [
    EnterSubmitDirective,
    TuiInputModule,
    TuiButton,
    TuiError,
    TuiFieldErrorPipe,
    AsyncPipe,
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
  ],
  templateUrl: "./forgot-password.component.html",
  styleUrl: "./forgot-password.component.scss",
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  isLoading: boolean = false;
  authError: string = "";
  userType: string = "";

  constructor(
    private forgotPasswordService: ForgotResetPasswordService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private alerts: TuiAlertService
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    this.userType = this.route.snapshot.paramMap.get("userType") || "";
  }

  submit() {
    if (this.forgotPasswordForm.valid) {
      this.isLoading = true;
      if (this.userType === "admin") {
        this.forgotPasswordService
          .requestResetPassword(this.forgotPasswordForm.value)
          .pipe(
            catchError((error) => {
              this.isLoading = false;
              this.authError = getHttpErrorMessage(error);
              this.forgotPasswordForm.setErrors({ invalid: true });
              this.alerts
                .open(getHttpErrorMessage(error), {
                  label: "User not found",
                  appearance: "negative",
                })
                .subscribe();
              this.forgotPasswordForm.reset();
              return of(null);
            })
          )
          .subscribe((res: any) => {
            this.isLoading = false;
            if (res) {
              this.alerts
                .open("Password reset link sent to your email", {
                  label: "Success",
                  appearance: "success",
                })
                .subscribe();
            }
          });
      }
      if (this.userType === "nurse") {
        this.forgotPasswordService
          .requestResetPasswordNurse(this.forgotPasswordForm.value)
          .pipe(
            catchError((error) => {
              this.isLoading = false;
              this.authError = getHttpErrorMessage(error);
              this.forgotPasswordForm.setErrors({ invalid: true });
              this.alerts
                .open(getHttpErrorMessage(error), {
                  label: "User not found",
                  appearance: "negative",
                })
                .subscribe();
              this.forgotPasswordForm.reset();
              return of(null);
            })
          )
          .subscribe((res: any) => {
            this.isLoading = false;
            if (res) {
              this.alerts
                .open("Password reset link sent to your email", {
                  label: "Success",
                  appearance: "success",
                })
                .subscribe();
            }
          });
      }
      if (this.userType === "client") {
        this.forgotPasswordService
          .requestResetPasswordClient(this.forgotPasswordForm.value)
          .pipe(
            catchError((error) => {
              this.isLoading = false;
              this.authError = getHttpErrorMessage(error);
              this.forgotPasswordForm.setErrors({ invalid: true });
              this.alerts
                .open(getHttpErrorMessage(error), {
                  label: "User not found",
                  appearance: "negative",
                })
                .subscribe();
              this.forgotPasswordForm.reset();
              return of(null);
            })
          )
          .subscribe((res: any) => {
            this.isLoading = false;
            if (res) {
              this.alerts
                .open("Password reset link sent to your email", {
                  label: "Success",
                  appearance: "success",
                })
                .subscribe();
            }
          });
      }
    } else {
      this.forgotPasswordForm.markAllAsTouched();
    }
  }
}
